import { Stack } from '@mui/material'
import { useGetAllWeeklyPresences } from '@src/api/home-api'
import { useGetAllPerson } from '@src/api/person-api'
import PeriodSelect from '@src/components/Homepage/PeriodSelect'
import PresencesDataTable from '@src/components/Homepage/PresencesDataTable'
import PageContainer from '@src/components/Layout/PageContainer'
import PageHeader from '@src/components/Layout/PageHeader'
import PageLoader from '@src/components/Loader/PageLoader'
import { EPeriod } from '@src/types/Dto/Home'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

const HomePage = () => {
  const { t } = useTranslation()
  const [selectedPeriod, setSelectedPeriod] = useState<EPeriod>(EPeriod.CurrentYear)

  const [data, isFetchingPresences] = useGetAllWeeklyPresences(selectedPeriod)
  const [persons, isFetchingPersons] = useGetAllPerson()

  const handlePeriodChange = (period: EPeriod) => {
    setSelectedPeriod(period)
  }

  if (isFetchingPresences || isFetchingPersons) {
    return <PageLoader />
  }
  return (
    <>
      <PageHeader
        title={t('breadcrumbs.home')}
        breadcrumbs={{
          path: [{ href: '/', label: t('breadcrumbs.home') }],
        }}
        actions={
          <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
            <PeriodSelect selectedPeriod={selectedPeriod} onPeriodChange={handlePeriodChange} />
          </Stack>
        }
      />
      <PageContainer sx={{ padding: 2, flexGrow: 1, overflow: 'hidden' }}>
        <PresencesDataTable persons={persons} data={data} />
      </PageContainer>
    </>
  )
}

export default HomePage
